module.exports = __webpack_public_path__ + "img/lk-double-up.01a5a38f.svg";